import React from 'react'
import { Typography, Button, Paper } from '@mui/material'
import { Link } from '@inertiajs/react'
import {
  Inbox as InboxIcon,
  Storage as StorageIcon,
  Key as KeyIcon,
  People as PeopleIcon,
  Folder as FolderIcon,
  FolderOpen as FolderOpenIcon,
} from '@mui/icons-material'
import { IconCircle } from '@/components/styled'

type IconType = 'inbox' | 'server' | 'key' | 'users' | 'folder' | 'folder-open'

interface EmptyStateProps {
  icon?: IconType
  title: string
  description?: string
  actionPath?: string
  actionText?: string
}

const iconMap: Record<IconType, React.ElementType> = {
  inbox: InboxIcon,
  server: StorageIcon,
  key: KeyIcon,
  users: PeopleIcon,
  folder: FolderIcon,
  'folder-open': FolderOpenIcon,
}

export default function EmptyState({
  icon = 'inbox',
  title,
  description,
  actionPath,
  actionText,
}: EmptyStateProps) {
  const IconComponent = iconMap[icon] || InboxIcon

  return (
    <Paper
      sx={{
        p: 6,
        textAlign: 'center',
        bgcolor: 'grey.50',
        border: '2px dashed',
        borderColor: 'grey.200',
      }}
    >
      <IconCircle>
        <IconComponent sx={{ fontSize: 40, color: 'grey.400' }} />
      </IconCircle>

      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>

      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {description}
        </Typography>
      )}

      {actionPath && actionText && (
        <Button component={Link} href={actionPath} variant="contained">
          {actionText}
        </Button>
      )}
    </Paper>
  )
}
